"use strict";
import { PostFormApi } from "../utils/func";
import { showQuestions } from "../renders/show_questions";
import { updateQuestionStatus } from "../events/query";

export const process_question_event = (e) => {
  e.preventDefault();
  let target = e.target;
  let id = target.getAttribute("data-id");
  let statusName = target.getAttribute("data-name");
  let status = target.getAttribute("data-status");
  let formData = {
    id,
    statusName,
    status,
    submit: true,
  };
  PostFormApi("../api/query/update_query.php", formData).then((res) => {
    let updatedQuestions = updateQuestionStatus(formData);
    showQuestions(updatedQuestions);
  });
};
